module.exports = __webpack_public_path__ + "media/images/faramia/placeholder_thumbnail-b716c86719dbbcc85a09113a41f81693.png";